import { Component, Input } from '@angular/core';
import { ContratoService } from 'administrativo-lib';
import { BaseResourceItemsComponent, Contrato, ContratoEnvolvidos, ContratoPncp, ContratoPncpService, FuncaoService, Login, PNCPService } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import * as toastr from 'toastr';
import { ContratoEnvolvidosService } from '../service/contrato-envolvido.service';

declare var $: any;

@Component({
  selector: 'lib-contrato-envolvidos-pncp',
  templateUrl: './contrato-envolvidos-pncp.component.html'
})
export class ContratoEnvolvidosPncpComponent extends BaseResourceItemsComponent<ContratoEnvolvidos> {

  @Input() contrato: Contrato;
  @Input() login: Login;

  public imaskConfig = {
    mask: Number,
    scale: 2,
    signed: true,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  public opcoesSimNaoBoolean: { id: boolean, nome: string }[] = [
    { id: true, nome: 'Sim' },
    { id: false, nome: 'Não' }
  ];

  public listaTipoEnvolvido = [
    { id: '1', nome: 'Gerenciadora' },
    { id: '2', nome: 'Participante' },
    { id: '3', nome: 'Não Participante' },
  ];


  constructor(
    private contratoService: ContratoService,
    private funcaoService: FuncaoService,
    protected confirmationService: ConfirmationService,
    protected contratoEnvolvidoService: ContratoEnvolvidosService
  ) {
    super(new ContratoEnvolvidos(), contratoEnvolvidoService);
    this.persistence = true;
  }


  protected afterInit(): void {
  }

  protected afterEdit(item: ContratoEnvolvidos) {
    if (!item.contrato) {
      item.contrato = new Contrato();
    }

    item.contrato.id = this.contrato.id
  }

  protected validSave(item: ContratoEnvolvidos): boolean {
    if (!item.tipo_envolvido) {
      toastr.warning('Preencha o tipo da parte envolvida');
      return false;
    }
    if (!item.cnpj) {
      toastr.warning('Preencha o CNPJ da parte envolvida');
      return false;
    }
   if (!this.funcaoService.validarCNPJ(item.cnpj)) {
      toastr.warning('O documento informado está inválido!')
      return;
    }
    if (!item.codigo_unidade) {
      toastr.warning('Preencha o código da unidade administrativa da parte envolvida');
      return false;
    }

    return true;
  }

  protected beforeSave(item: ContratoEnvolvidos): void {
  }


  verificarTipoDuplicado(entitySelecionado: ContratoEnvolvidos, index: number): void {
    const tipoSelecionado = entitySelecionado.tipo_envolvido;
    let tipoJaExiste

    if(tipoSelecionado == '1'){
      tipoJaExiste = this.lista.some((ent, idx) =>
        idx !== index && ent.tipo_envolvido === tipoSelecionado
      );
    }

    if (tipoJaExiste) {
      toastr.warning('Este tipo já foi selecionado a opção Gerenciadora!');
      entitySelecionado.tipo_envolvido = null; // limpa o campo
    }
  }


  ngOnInit(): void {
    // if (this.contrato && !this.contrato?.contrato_pncp) {
    //   this.contrato.contrato_pncp = new ContratoPncp();
    //   this.contrato.contrato_pncp.categoria_processo = this.contrato.licitacao.categoria_processo
    // }
  }

  ngOnChanges(): void {
    // if (this.contrato && !this.contrato?.contrato_pncp) {
    //   this.contrato.contrato_pncp = new ContratoPncp();
    //   this.contrato.contrato_pncp.categoria_processo = this.contrato?.licitacao?.categoria_processo
    // }
  }
}
